import React, { SyntheticEvent } from "react";
import getCustomizableProductUrl from "~/common/helpers/getCustomizableProductUrl";
import setWindowLocationHref from "~/common/navigation/setWindowLocationHref";
import { Product } from "~/common/Store/models/ProductListing";
import { groupingSelected, valid } from "../validations";
import ValidationError from "../ValidationError";
import { cls } from "cls";
interface CustomizableProps {
  product: Product;
  itemNumber: string;
  isCustomizable: boolean;
  hasCustomizableProductsOverride: boolean;
  isVirtual?: boolean;
  hasMultipleVGGrouping?: boolean;
  groupingValue?: string;
  handleAddToCart?: (event: SyntheticEvent) => void;
  displayRequiredCustomization?: boolean;
  link?: string;
  customizationUrl: string;
  isOnCompareProductsPage: boolean;
  setError: React.Dispatch<React.SetStateAction<Readonly<ValidationError> | undefined>>;
  isCompareWithProductBox?: boolean;
  productListingView?: string;
  undoBtnContainerStyle?: boolean;
}
export default function Customizable({
  isCompareWithProductBox,
  isOnCompareProductsPage,
  productListingView,
  undoBtnContainerStyle,
  product,
  itemNumber,
  isCustomizable,
  hasCustomizableProductsOverride,
  isVirtual,
  hasMultipleVGGrouping,
  groupingValue,
  handleAddToCart,
  displayRequiredCustomization,
  link = "",
  customizationUrl,
  setError
}: CustomizableProps) {
  const handleCustomize = (event: SyntheticEvent) => {
    event.preventDefault();
    if (!isVirtual) {
      window.location.href = getCustomizableProductUrl(product.customizationUrl, itemNumber);
    }
    const isValid = valid({
      product,
      quantity: product.startBuy,
      groupingValue,
      validationsToRun: [groupingSelected]
    });
    if (!isValid.isError && isVirtual) {
      if (!hasMultipleVGGrouping && groupingValue) {
        setWindowLocationHref(getCustomizableProductUrl(customizationUrl, groupingValue));
      }
      if (hasMultipleVGGrouping && handleAddToCart) {
        handleAddToCart(event);
      }
    } else if (isValid.isError) {
      setError(isValid.error);
    }
  };
  const comparisonPageStyles = isOnCompareProductsPage ? "leading-3 text-sm-1/2 h-8 mb-0" : "";
  return <div className={cls("cartAndQuantity", undoBtnContainerStyle && productListingView === "grid" && "-ml-[30px]", isCompareWithProductBox && "text-left")} data-sentry-component="Customizable" data-sentry-source-file="Customizable.tsx">
      {displayRequiredCustomization || hasCustomizableProductsOverride && isCustomizable ? <button type="button" className={`btn btn-block btn-custom btn-icon--customize btn-small leading-3 ${comparisonPageStyles}`} data-testid="customizeBtn" onClick={handleCustomize}>
          <img className="btn-icon-wand" src="//cdnimg.webstaurantstore.com/uploads/blog/2019/3/wand-icon.png" alt="Customize Now" />
          Customize Now
        </button> : <a href={link}>
          <button type="button" className="btn btn-block btn-custom btn-small" data-testid="learnMoreBtn">
            Learn More
          </button>
        </a>}
    </div>;
}